<template>
  <div>
    <!-- <header class="header pc-header">
		<div class="wrap">
			<a href="#" class="logo wow fadeInLeft"><img src="/static/img/logo.png" /></a>
			<div class="r-top wow fadeInRight">
				<nav class="nav">
					<ul>
						<li><a href="index.html" class="inNav">首页</a></li>
						<li><a href="参与中心.html" class="inNav">参与中心</a></li>
						<li>
							<a href="javascript:;" class="inNav">学术支持</a>
							<div class="sub-nav">
								<a href="https://www.cnki.net/">中国知网</a>
								<a href="http://www.wanfangdata.com.cn/index.html">万方数据</a>
								<a href="https://www.ncbi.nlm.noh.gov/">Pubmed</a>
								<a href="https://www.embase.com/login">Embase</a>
								<a href="https://www.cochranelibrary.com/">Cochranelibrary</a>
							</div>
						</li>
						<li class="active"><a href="发表论文.html" class="inNav">发表论文</a></li>
						<li><a href="加入我们.html" class="inNav">加入我们</a></li>
					</ul>
				</nav>
				<a href="javascript:;" class="apply-data-btn">申请数据</a>
			</div>
		</div>
	</header> -->
    <!--to-top-->
    <div class="to-top"><img src="/static/img/to-top.png" /></div>
    <div class="pop-mask"></div>

    <!--      <div class="mobile-header">-->
    <!--		<div class="wrap">-->
    <!--			<div class="m-box">-->
    <!--				<div class="logo"><a href="#"><img src="/static/img/logo.png" /></a></div>-->
    <!--				<div class="r-box">-->
    <!--					<a href="javascript:;" class="apply-data-btn">申请数据</a>-->
    <!--					<div class="nav-btn"><span></span><span></span><span></span></div>-->
    <!--				</div>-->

    <!--				<div class="nav-list">-->
    <!--					<ul>-->
    <!--						<li class="active"><a href="index.html" class="inNav nav-on">首页</a></li>-->
    <!--						<li><a href="参与中心.html" class="inNav nav-on">参与中心</a></li>-->
    <!--						<li>-->
    <!--							<a href="javascript:;" class="inNav">学术支持</a>-->
    <!--							<div class="sub-nav">-->
    <!--								<a href="https://www.cnki.net/">中国知网</a>-->
    <!--								<a href="http://www.wanfangdata.com.cn/index.html">万方数据</a>-->
    <!--								<a href="https://www.ncbi.nlm.noh.gov/">Pubmed</a>-->
    <!--								<a href="https://www.embase.com/login">Embase</a>-->
    <!--								<a href="https://www.cochranelibrary.com/">Cochranelibrary</a>-->
    <!--							</div>-->
    <!--						</li>-->
    <!--						<li><a href="发表论文.html" class="inNav nav-on">发表论文</a></li>-->
    <!--						<li><a href="加入我们.html" class="inNav nav-on">加入我们</a></li>-->
    <!--					</ul>-->
    <!--				</div>-->
    <!--			</div>-->
    <!--		</div>-->
    <!--	</div>-->
    <div class="inner-banner article-banner pc-inner-banner"></div>
    <div class="mobile-inner-banner article-banner">
      <img src="/static/img/article-banner.png" />
    </div>
    <div class="inner-main">
      <div class="article-con">
        <div class="article-con-title">
          <h4 class="article-con-title-cn">学术指南</h4>
          <h5 class="article-con-title-eng">ACADEMIC GUIDE</h5>
        </div>
        <div class="article-con-rows">
          <a
            target="_blank"
            href="https://kns.cnki.net/kcms/detail/detail.aspx?dbcode=CJFD&dbname=CJFDAUTO&filename=ZGWK202105011&v=rqJ%25mmd2B4GDfGoD3HNKRSco89rdggb8NnyLdBX1QlIekXFjxX5dYXxFaDDfDaEOd4%25mmd2BOC"
          >
            <div class="article-item wow fadeInLeft">
              <div class="item-pic">
                <img class="item-pic-img" src="/static/img/publish/c-mbs.png" />
              </div>
              <p>
                《减重与代谢外科手术病人影像学检查临床适用性评价指南（2021年版）》
              </p>
            </div>
          </a>
          <a
            target="_blank"
            href="https://kns.cnki.net/kcms/detail/detail.aspx?dbcode=CJFD&dbname=CJFDLAST2022&filename=ZGWK202201004&uniplatform=NZKPT&v=udo_pgyGg4VXtoN2p8a2c98mOtSNS0CSEhVVD-aOlq-AoELXtIZ7aiEoIHuEOlOl"
          >
            <div class="article-item wow fadeInLeft">
              <div class="item-pic">
                <img class="item-pic-img" src="/static/img/publish/t2.png" />
              </div>
              <p>
                《腹腔镜胃袖状切除术日间手术中国专家共识（2021版）》
              </p>
            </div>
          </a>
          <a
            target="_blank"
            href="https://kns.cnki.net/kcms/detail/detail.aspx?dbcode=CJFD&dbname=CJFDLAST2022&filename=ZGWK202201003&uniplatform=NZKPT&v=udo_pgyGg4XX_jmryWLmR8Hu5DbFETA8vqenm9UjYhWCO0vGwd7SxHUt85b71DRB"
          >
            <div class="article-item wow fadeInLeft">
              <div class="item-pic">
                <img class="item-pic-img" src="/static/img/publish/t3.png" />
              </div>
              <p>
                《中国减重与代谢外科围手术期静脉血栓栓塞症预防指南（2021版）》
              </p>
            </div>
          </a>

          <a target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/35471478/">
            <div class="article-item wow fadeInLeft">
              <div class="item-pic">
                <img class="item-pic-img" src="/static/img/publish/t4.png" />
              </div>
              <p>
                Clinical practice guideline for body composition assessment
                based on upper abdominal magnetic resonance images annotated
                using artificial intelligence
              </p>
            </div>
          </a>
        </div>
      </div>

      <div class="article-con">
        <div class="article-con-title">
          <h4 class="article-con-title-cn">数据报告</h4>
          <h5 class="article-con-title-eng">DATA REPORT</h5>
        </div>
        <div class="article-con-rows-column">
          <div class="article-con-rows">
            <a
              target="_blank"
              href="https://kns.cnki.net/kcms/detail/detail.aspx?dbcode=CJFD&dbname=CJFDLAST2019&filename=ZGWK201902016&v=6UnhLbApRaLTHiAOq61LcOqzvc2nSe6VrRTqB%25mmd2F2SRc0Vf%25mmd2FCn%25mmd2Fz3xRwYyAcLLSKqw"
            >
              <div class="article-item wow fadeInLeft">
                <div class="item-pic">
                  <img class="item-pic-img" src="/static/img/view01.jpg" />
                </div>
                <p>《大华北减重与代谢手术临床资料数据库年度报告(2018)》</p>
              </div>
            </a>
            <a
              target="_blank"
              href="https://kns.cnki.net/kcms/detail/detail.aspx?dbcode=CJFD&dbname=CJFDLAST2020&filename=ZGWK202004018&v=jwIxawG2QuX44GmfpiETooV6wbfV9NzDpxWSGfeElqzLRBbnR7ZUVzDxiNBBPRoz"
            >
              <div class="article-item wow fadeInRight">
                <div class="item-pic">
                  <img class="item-pic-img" src="/static/img/view02.jpg" />
                </div>
                <p>《大华北减重与代谢手术临床资料数据库2019 年度报告》</p>
              </div>
            </a>
            <a
              target="_blank"
              href="https://kns.cnki.net/kcms/detail/detail.aspx?dbcode=CJFD&dbname=CJFDLAST2021&filename=ZGWK202105012&uniplatform=NZKPT&v=rqJ-4GDfGoAhkn6tSUqX07u2aGeYFg0NAtSb7aRrJjTLGw3MhKxMQbG-AKexvcZL"
            >
              <div class="article-item wow fadeInRight">
                <div class="item-pic">
                  <img class="item-pic-img" src="/static/img/publish/two.png" />
                </div>
                <p>《大中华减重与代谢手术数据库2020 年度报告》</p>
              </div>
            </a>
          </div>

          <div class="article-con-rows">
            <a
              target="_blank"
              href="https://kns.cnki.net/kcms/detail/detail.aspx?dbcode=CJFD&dbname=CJFDAUTO&filename=ZGWK202205016&uniplatform=NZKPT&v=udo_pgyGg4VH7VFseOxeS00X13iIw6SE3fWOQzSMkmUbiLnYYY29RKr-Mk4dcrZJ"
            >
              <div class="article-item wow fadeInRight">
                <div class="item-pic">
                  <img
                    class="item-pic-img"
                    src="/static/img/publish/data4.png"
                  />
                </div>
                <p>《大中华减重与代谢手术数据库2021年度报告》</p>
              </div>
            </a>
            <a
              target="_blank"
              href="https://www.zgsyz.com/zgsywk/CN/Y2023/V43/I05/540"
            >
              <div class="article-item wow fadeInRight">
                <div class="item-pic">
                  <img
                    class="item-pic-img"
                    src="/static/img/publish/data5.png"
                  />
                </div>
                <p>《大中华减重与代谢手术数据库2022年度报告》</p>
              </div>
            </a>
            <a
                target="_blank"
                href="https://kns.cnki.net/kcms2/article/abstract?v=0uJvuxkiqRvDfAw-g41e_vx_pZ31h8mH1uRo1L6UjvV5gw5we_3L0nhNB0GVCklUPM_WrkDoQ1am1eTp49avJZeGuO-aaHUG018AwBU2m9CfIeKG-bC9HQ==&uniplatform=NZKPT"
            >
              <div class="article-item wow fadeInRight">
                <div class="item-pic">
                  <img
                      class="item-pic-img"
                      src="/static/img/publish/data6.png"
                  />
                </div>
                <p>《大中华减重与代谢手术数据库2023年度报告》</p>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="article-con">
        <div class="article-con-title">
          <h4 class="article-con-title-cn">研究论文</h4>
          <h5 class="article-con-title-eng">RESEARCH PAPER</h5>
        </div>
        <div class="article-con-rows-column">
          <div class="article-con-rows">
            <a target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/34132996/">
              <div class="article-item wow fadeInLeft">
                <div class="item-pic">
                  <img class="item-pic-img" src="/static/img/publish/one.png" />
                </div>
                <p>
                  The Choice of Gastric Bypass or Sleeve Gastrectomy for
                  Patients Stratified by Diabetes Duration and Body Mass Index
                  (BMI) level: Results from a National Registry and
                  Meta-analysis. Obes Surg
                </p>
              </div>
            </a>
            <a
              target="_blank"
              href="https://kns.cnki.net/kcms/detail/detail.aspx?dbcode=CJFD&dbname=CJFDLAST2021&filename=ZGWK202103020&uniplatform=NZKPT&v=rqJ-4GDfGoCGjozdWESocQSQ-nC91C__VcVl0p66Aqr5sOK43SBXcixXl8KTbqFj"
            >
              <div class="article-item wow fadeInRight">
                <div class="item-pic">
                  <img class="item-pic-img" src="/static/img/publish/vte.png" />
                </div>
                <p>
                  《京津冀晋地区减重与代谢外科围手术期静脉血栓栓塞症防治现状调查分析》
                </p>
              </div>
            </a>
            <a
              target="_blank"
              href="https://kns.cnki.net/kcms/detail/detail.aspx?dbcode=CJFD&dbname=CJFDLAST2020&filename=ZGWK202004023&uniplatform=NZKPT&v=jwIxawG2QuWbrjTc3wncmvT2u8ktDe1LepkPsA0md7ebzynJMZ-6vk4ilQM-4-cj"
            >
              <div class="article-item wow fadeInRight">
                <div class="item-pic">
                  <img class="item-pic-img" src="/static/img/publish/fs.png" />
                </div>
                <p>
                  《减重与代谢手术病人垂体磁共振检查临床适用性评价》
                </p>
              </div>
            </a>

            <a
              target="_blank"
              href="https://pubmed.ncbi.nlm.nih.gov/37525550/"
            >
              <div class="article-item wow fadeInRight">
                <div class="item-pic">
                  <img class="item-pic-img" src="/static/img/publish/management.png" />
                </div>
                <p>
                  Management and outcomes of gastric leak after sleeve gastrectomy: results from the 2010-2020 national registry
                </p>
              </div>
            </a>
          </div>

          <div class="article-con-rows">
            <a target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/34167531/">
              <div class="article-item wow fadeInLeft">
                <div class="item-pic">
                  <img
                    class="item-pic-img"
                    src="/static/img/publish/base-NAFLD protocol.png"
                  />
                </div>
                <p>
                  Bariatric surgery for non-alcoholic fatty liver disease in
                  individuals with obesity (Base-NAFLD): protocol of a
                  prospective multicenter observational follow-up study
                </p>
              </div>
            </a>

            <a target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/36175102/">
              <div class="article-item wow fadeInLeft">
                <div class="item-pic">
                  <img
                    class="item-pic-img"
                    src="/static/img/publish/ncbi.png"
                  />
                </div>
                <p>
                  Efficacy and safety of one anastomosis gastric bypass versus
                  Roux-en-Y gastric bypass for type 2 diabetes remission
                  (ORDER): protocol of a multicentre, randomised controlled,
                  open-label, superiority trial
                </p>
              </div>
            </a>
            <a target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/36789640/">
              <div class="article-item wow fadeInLeft">
                <div class="item-pic">
                  <img class="item-pic-img" src="/static/img/publish/t5.png" />
                </div>
                <p>
                  Metabolic and bariatric surgery in China: A summary of the
                  Greater China Metabolic and Bariatric Surgery Database and
                  comparison with other international registry
                  databases
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer">
      <div class="wrap">
        <a href="#" class="f-logo wow fadeInLeft"
          ><img src="/static/img/f-logo.png"
        /></a>
        <!--			<p class="wow fadeInRight">地址：北京丰台区汉威广场二区1号楼6M层</p>-->
        <p class="wow fadeInRight">
          Copyright © 2017-2020 大中华减重与代谢外科数据平台京ICP备17044059号
        </p>
        <p>
          平台支持：<a target="_blank" href="http://www.edocdata.com/"
            >北京易得医数科技有限责任公司</a
          >
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
require("../../static/js/common.js");
require("../../static/js/swiper.min.js");
require("../../static/js/inner.js");
require("../../static/laydate/laydate.js");
import VueCountUp from "vue-countupjs";
import { WOW } from "wowjs";
export default {
  components: { VueCountUp },
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      var wow = new WOW({
        live: false
      });
      wow.init();
    });
  }
};
</script>

<style scoped>
/*@import url('../../static/css/common.css');*/
/*@import url('../../static/css/swiper.min.css');*/
/*@import url('../../static/css/inner.css');*/
/*@import url('../../static/css/respond.css');*/
</style>



// WEBPACK FOOTER //
// src/views/publish.vue